// @ts-nocheck
import React, { useState } from "react";
import { useQueryClient } from "react-query";
import moment from "moment";
import { AsyncScrollTable } from "components/ScrollTable/ScrollTable";
import genRequest from "includes/request";
import { t } from "i18next";
import AuthorPreview from "components/User/AuthorPreview/AuthorPreview";
import PageHeadBar from "components/HeadBar/PageHeadBar";
import PreviewDrawer from "components/PreviewDrawer/PreviewDrawer";
import ReportPreview, { reportUserId } from "./ReportPreview";
import useSelect from "hooks/useSelect";

export default function ReportingPage() {
	const [active, setActive] = useState(false);
	const {confirmDelete} = useSelect();
	const [selected, setSelected] = useState([]);
	const QCL = useQueryClient();
	const cols = [
		{
			title: "Titre",
			name: "title",
			classes: "post-title-cell",
			component: TitleCell
		},
		{
			title: "Author",
			name: "Author",
			classes: "post-author-cell",
			component: AuthorCell,
			sort: false
		},
		{
			title: "Plateforme",
			name: "address"
		},
		{
			title: "Date de publication",
			name: "publishedDate",
			classes: "post-date-cell",
			component: DateCell
		}
	];

	function handleDelete() {
		let title = selected?.length + " publications seront supprimées, voulez vous continuer ?";
		if (selected?.length < 2)
			title = "La publication \"" +selected[0].title + "\" sera supprimée, voulez vous continuer ?";
		confirmDelete(
			() => {
				delSelecteds();
			},
			null,
			title
		);
	}

	function delSelecteds() {
		let proms = [];
		for (let x in selected)
			if (selected[x]?.id)
				proms.push(new Promise((resolve, reject) => {
					setTimeout(() => {
						genRequest(
							"posts/" + selected[x]?.id,
							null,
							"delete"
						).then((resp) => {
							resolve(resp);
						}, reject);
					}, 500 * x);
				}));
		return (Promise.allSettled(proms).then(() => {
			QCL.resetQueries(["posts", "type", 15]);
			setSelected([]);
		}));
	}

	return (
		<div className="ReportPage d-flex flex-column overflow-hidden">
			<PageHeadBar
				title="Reporting"
				buttons={[
					(selected?.length ?
						{
							forceTitle: true,
							title: t("Commons.DELETE") + " " + t("Commons.ITEMS", {count: selected.length}),
							classes: "btn-red btn",
							onClick: () => handleDelete()
						}
						: false
					)
				]}
				search={false}
			/>
			<AsyncScrollTable
				queryFn={() => genRequest("posts/type/" + 15)}
				queryKey={["posts", "type", 15]}
				cols={cols}
				sortBy="publishedDate"
				revSort={true}
				itemId="id"
				onItemClick={setActive}
				activeId={active?.id ? active?.id : false}
				max={30}
				setSelected={setSelected}
				checkbox={true}
			/>
			{
				active &&
				<PreviewDrawer
					report={active}
					child={ReportPreview}
					fullScreen={true}
					isOpen={active}
					childProps={{
						report: active
					}}
					onClose={() => setActive(false)}
				/>
			}
		</div>
	);
}

function TitleCell({item}) {
	return (
		<div>
			{item.title}
		</div>
	);
}

function AuthorCell({item}) {
	let datas = {};
	try { datas = JSON.parse(item.txt); } catch(e) {}
	const userId = reportUserId(item, datas);
	return (
		<AuthorPreview
			employeeId={userId}
			className="posts-table-author-preview mb-0"
			imgWidth={20}
			format={
				[
					"firstName lastName"
				]
			}
			modifiers={{
				lastName: (item) => item.toUpperCase()
			}}
		/>
	);
}

function DateCell({item}) {
	return (
		<div className="d-flex align-items-center">
			{moment(item.publishedDate).format(t("Events.TILE_DATE_FORMAT"))}
		</div>
	);
}
